export default "__VITE_ASSET__tUrYxNXq__"